import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import $ from 'jquery';
import { Container, Row, Col, Button } from "reactstrap";
import * as url from "../../helpers/url_helper";
import { API_URL } from "../../helpers/api_helper";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import headers from "../Utility/headers";
import { Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
import AnalyzerList from "./AnalyzerList";

class CouponAnalyzer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TotalCustomers: 0,
            couponScanner: [],
            loading: false,
            store: '',
            newStore: '',
            siteUrl: {},
            couponsData: {}, // Store coupons data in an object
            websiteUrls: {}, // Store website URLs in an object
            domain: '',
            handle: '',
            query: '',
            id: '',
            showCoupons: false,
            // domain: 'cozyearth.com',
            // handle: 'cozyearth',
            // query: 'cozy earth,cozyearth',
            scannerWebsite: [],
            merchantInfo: {},
            uniqueCoupons: []
        };
    }


    notify = (type, message) => {
        switch (type) {
            case 'info':
                toast.info(message);
                break;
            case 'error':
                toast.error(message);
                break;
            case 'success':
                toast.success(message);
                break;
            default:
                break;
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const [key, id] = name.split('_');
        if (key === 'site') {
            this.setState(prevState => ({
                siteUrl: {
                    ...prevState.siteUrl,
                    [name]: value
                }
            }));
        } else if (key === 'website') {
            this.setState(prevState => ({
                websiteUrls: {
                    ...prevState.websiteUrls,
                    [name]: value // Update specific website URL
                }
            }));
        } else if (key === 'coupons') {
            this.setState(prevState => ({
                couponsData: {
                    ...prevState.couponsData,
                    [name]: value // Update specific coupon
                }
            }));
        }
    };


    getDomainName = (domain) => {
        if (!domain) return '';
        const parts = domain.split('.');
        if (parts.length < 2) return '';
        if (parts.length === 3) {
            if (parts[0] === 'www') {
                return parts[1];
            }
            return parts[0];
        }
        return parts[parts.length - 2];
    }

    async componentDidMount() {
    }

    handleErrorResponse(response, results) {
        if (response.status === 401) {
            this.notify('error', `Unauthorized: ${results.message || "You are not authorized to perform this action"}`);
            window.location.href = "/logout";
        } else if (response.status === 500) {
            this.notify('error', `Server Error: ${results.message || "Something went wrong"}`);
        } else {
            this.notify('error', `Unexpected Error: ${response.status} - ${results.message || "Please try again"}`);
        }
    }

    handleSearchInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    generateLinksAndCoupons = async (e) => {
        e.preventDefault();
        $("#loadingIcon").text("Fetching Links ...").css('color', 'red');
        const { domain, handle, query } = this.state;
        if (!domain || !handle || !query) {
            this.notify('error', "Please fill all the fields");
            $("#loadingIcon").text("").css('color', 'green');
            return;
        }

        this.setState({ loading: true });

        await Promise.all([
            fetch(`${API_URL}${url.GENERATE_LINKS}?domain=${domain}&handle=${handle}&query=${query}`, {
                method: 'get',
                headers: headers()
            })

        ]).then(async ([generatedLinks]) => {
            try {
                const generated_response = await generatedLinks.json();
                if (!generated_response?.status) {
                    this.notify('error', "Error generating links");
                }

                const valid_links = Object.fromEntries(Object.entries(generated_response?.data).filter(([_, values]) => values.length > 0));
                const results = await Promise.all(
                    Object.entries(valid_links).map(async ([key, values]) => {
                        const response = await fetch(
                            `${API_URL}${url.COLLECT_COUPONS_FROM_WEBSITE}?links=${values.join(',')}&website=${key}`,
                            { method: 'get', headers: headers() }
                        );
                        const data = await response.json();
                        return { [key]: data.result }
                    })
                )
                const nonEmptyWithKeys = results
                    .flatMap(obj =>
                        Object.entries(obj)
                            .filter(([, value]) => Array.isArray(value) && value.length > 0)
                            .map(([key, value]) => ({ [key]: value }))
                    );


                // All Unique Coupons
                const uniqueCoupons = Array.from(new Set(
                    results.flatMap(obj => Object.values(obj).flat())
                ))

                const records = [];

                for (const item of nonEmptyWithKeys) {
                    const key = Object.keys(item)[0];
                    const value = item[key];
                    const getWebsite = valid_links[key] || [];
                    records.push({
                        website: key,
                        links: getWebsite.join(','),
                        numberOfCoupons: value.length,
                    });
                }

                this.setState({ leakCoupons: records, uniqueCoupons });
                this.setState({ showCoupons: true });

                // await this.getCouponScanner(store);
                this.notify('success', "Coupon scanner updated successfully");
                $("#loadingIcon").text("").css('color', 'green');
                this.setState({ loading: false });

            } catch (err) {
                console.log(`Error 1: ${JSON.stringify(err)}`);
                this.notify('error', "Error generating links");
                $("#loadingIcon").text("").css('color', 'green');
                this.setState({ loading: false });
            }
        }).catch(err => {
            console.error(`Error2: ${err}`);
            this.notify('error', "Error generating links");
            $("#loadingIcon").text("").css('color', 'green');
            this.setState({ loading: false });
            return;
        })
    }

    downloadPDF = () => {
        const { leakCoupons, uniqueCoupons } = this.state;

        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // Create the content for printing
        const content = `
            <html>
                <head>
                    <title>Coupon Analyzer Report</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        h2 { color: #333; }
                        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                        .coupon-list { margin-top: 20px; }
                    </style>
                </head>
                <body>
                    <h2>Websites</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Website</th>
                                <th>Links</th>
                                <th>Number of Coupons</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${leakCoupons?.length > 0 && leakCoupons?.map(item => `
                                <tr>
                                    <td>${item.website}</td>
                                    <td>${item.links}</td>
                                    <td>${item.numberOfCoupons}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    
                    <div class="coupon-list">
                        <h2>Coupons</h2>
                        <p style="font-size: 12px; font-weight: 500; color: #020; text-align: justify;">${uniqueCoupons.join(', ')}</p>
                    </div>
                </body>
            </html>
        `;

        // Write the content to the new window
        printWindow.document.write(content);
        printWindow.document.close();

        // Wait for content to load then print
        printWindow.onload = function () {
            printWindow.print();
            // Close the window after printing
            printWindow.onafterprint = function () {
                printWindow.close();
            };
        };
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Coupon Analyzer</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={this.props.t(`Coupon Analyzer`)}
                            breadcrumbItem={this.props.t(`Coupon Analyzer`)}
                        />
                        <ToastContainer />
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={this.generateLinksAndCoupons}>
                                            <FormGroup className="row mb-4 justify-content-center">
                                                <Label
                                                    htmlFor="horizontal-name-Input"
                                                    className="col-sm-1 col-form-label text-right"
                                                >
                                                    Domain <span className="text-danger">*</span>
                                                </Label>
                                                <Col sm={3}>
                                                    <Input
                                                        type="text"
                                                        name="domain"
                                                        placeholder="Domain (e.g. example.com)"
                                                        className="form-control"
                                                        id="horizontal-name-Input"
                                                        onChange={this.handleSearchInputChange}
                                                        value={this.state.domain}
                                                        required
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row mb-4 justify-content-center">
                                                <Label
                                                    htmlFor="horizontal-handle-Input"
                                                    className="col-sm-1 col-form-label text-right"
                                                >
                                                    Handle <span className="text-danger">*</span>
                                                </Label>
                                                <Col sm={3}>
                                                    <Input
                                                        type="text"
                                                        name="handle"
                                                        placeholder="Handle (e.g. example)"
                                                        className="form-control"
                                                        id="horizontal-icon-Input"
                                                        onChange={this.handleSearchInputChange}
                                                        value={this.state.handle}
                                                        required
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup className="row mb-4 justify-content-center">
                                                <Label
                                                    htmlFor="horizontal-email-Input"
                                                    className="col-sm-1 col-form-label text-right"
                                                >
                                                    Query <span className="text-danger">*</span>
                                                </Label>
                                                <Col sm={3}>
                                                    <Input
                                                        type="text"
                                                        name="query"
                                                        placeholder="Query"
                                                        className="form-control"
                                                        id="horizontal-query-Input"
                                                        value={this.state.query}
                                                        onChange={this.handleSearchInputChange}
                                                        required
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup className="row justify-content-center">
                                                <Col sm={2}>
                                                    <div>
                                                        <Button
                                                            type="submit"
                                                            color="primary"
                                                            className="w-md"
                                                        >
                                                            Fetching
                                                            {this.state.loading && <i className="fa fa-spinner fa-spin"></i>}
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {this.state.showCoupons && (
                            <Row>
                                <Col xl={12}>
                                    <h5 style={{ fontWeight: 'lighter', fontSize: '15px', color: '#020', marginBottom: '10px' }}>List of Coupon Scanner</h5>
                                    <Button color="primary" onClick={this.downloadPDF} className="mb-3 float-right">Download PDF</Button>
                                </Col>
                                <Col xl={12}>
                                    <Card>
                                        <CardBody>
                                            <AnalyzerList
                                                leakCoupons={this.state.leakCoupons}
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xl={12}>
                                    <h5 style={{ fontWeight: 'lighter', fontSize: '15px', color: '#020', marginBottom: '10px' }}>List of Leak Coupons</h5>
                                    <Card>
                                        <CardBody>
                                            {this.state.uniqueCoupons.join(', ')}
                                        </CardBody>
                                    </Card>

                                </Col>
                            </Row>

                        )}
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

CouponAnalyzer.propTypes = {
    t: PropTypes.any
};

export default withTranslation()(CouponAnalyzer);